import React from 'react'
import { Box, CircularProgress } from '@material-ui/core'

type Props = {
  height?: number | string
}

export function Loader({ height = '100%' }: Props): React.ReactElement {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height={height}
      data-testid="loader"
    >
      <CircularProgress />
    </Box>
  )
}
